export default "__VITE_ASSET__a8ce9f99__"